import styled from "styled-components";
import { borderTop1px } from "../../../utils/style/mixin";

const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${borderTop1px({})};
  width: 100%;
  height: 3rem;
  background-color: #fff;
  z-index: 10;
  padding: .2rem;
`;

const ImageComtainer = styled.div`
  position: relative;
  width: 2.6rem;
  height: 2.6rem;
  margin-right: 0.2rem;
  overflow: hidden;
  display:flex;
  justify-content: center;
  align-items: center;
  img {
    width: 2.6rem;
    height: auto;
    border-radius: 0.16rem;
  }
  .icon-corner-sign {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    line-height: 1;
    padding: 0.08rem 0.2rem;
    background: #c71622;
    border-top-left-radius: 0.16rem;
    border-bottom-right-radius: 0.04rem;
    color: #fff;
    font-size:.22rem;
    &.over {
      color: #fff;
      background-color: #8a8a8a;
    }
  }
`;

const InfoComtainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const InfoTitle = styled.div`
  word-break: break-all;
  font-size: 0.28rem;
  color: #252525;
  font-weight: bold;
  line-height: 1.3;
  padding-top:.04rem
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

const InfoDetail = styled.div`
  .p-middle {
    color: #999;
    .p-time {
      font-size: 0.24rem;
      i {
        color: #252525;
      }
    }
    .p-category,.p-addr {
      font-size: 0.24rem;
      margin-top: 0.18rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      line-height:1.2;
      overflow: hidden;
      color:#999999;
      i {
        color: #252525;
      }
    }
  }
  .p-bid {
    font-size: 0.24rem;
    color: #999;
    font-family: PingFangSC-Light;
    margin-top: 0.2rem;
    .p-bid-divide {
      display: inline-block;
      margin: 0 0.2rem;
      width: 1px;
      height: 0.2rem;
      vertical-align: middle;
      background-color: silver;
    }
    i {
      color: #222;
    }
  }
  .p-label{
    margin-right: 0.12rem;
    display: inline-block;
  }
`;

export { ItemContainer, ImageComtainer, InfoComtainer, InfoTitle, InfoDetail };
